import Vue from 'vue'
import Vuex from 'vuex'
import { initAuthentication, initUser } from '@/assets/js/userSessionDefaults'

Vue.use(Vuex)

const user = {
  namespaced: true,
  state: {
    authentication: initAuthentication(),
    user: initUser(),
  },
  getters: {
    getAuthentication(state) {
      return state.authentication
    },
    getUser(state) {
      return state.user
    },
  },
  mutations: {
    setAuthentication(state, payload) {
      state.authentication = Object.assign([], payload)
    },
    setUser(state, payload) {
      state.user = Object.assign([], payload)
    },
    removeUser(state, payload) {
      sessionStorage.removeItem('user')
      state.user = {}
    }
  },
  actions: {
    setAuthentication(context, payload) {
      context.commit('setAuthentication', payload)
    },
    setUser(context, payload) {
      context.commit('setUser', payload)
    },
    removeUser(context) {
      context.commit('removeUser')
    }
  },
}

const loading = {
  namespaced: true,
  state: {
    loadComponent: false
  },
  getters: {
    getLoadComponent(state) {
      return state.loadComponent
    },
  },
  mutations: {
    setLoadComponent(state, payload) {
      state.loadComponent = payload
      // Fix can not scroll down after loading spinner
      setTimeout(() => {
        if(state.loadComponent) {
          $("html").addClass("modal-mask-open")
        } else {
          $("html").removeClass("modal-mask-open")
        }
      }, 200)
    },
  },
  actions: {
    setLoadComponent(context, payload) {
      context.commit('setLoadComponent', payload)
    },
  },
}

const specialList = {
  namespaced: true,
  state: {
    specialist: false
  },
  getters: {
    getSpecialist(state) {
      return state.specialist
    }
  },
  mutations: {
    setSpecialist(state, payload) {
      state.specialist = payload
    }
  },
  actions: {
    setSpecialist(context, payload) {
      context.commit('setSpecialist', payload)
    }
  },
}

const claimantConfirm = {
  namespaced: true,
  state: {
    claimantConfirm: false
  },
  getters: {
    getClaimantConfirm(state) {
      return state.claimantConfirm
    }
  },
  mutations: {
    setClaimantConfirm(state, payload) {
      state.claimantConfirm = payload
    }
  },
  actions: {
    setClaimantConfirm(context, payload) {
      context.commit('setClaimantConfirm', payload)
    }
  },
}

const bookingRequest = {
  namespaced: true,
  state: {
    bookingRequestData: null
  },
  getters: {
    getBookingObject(state) {
      return state.bookingRequestData
    }
  },
  mutations: {
    setBookingRequestObject(state, payload) {
      state.bookingRequestData = Object.assign([], payload)
    }
  },
  actions: {
    setBookingRequestObject(context, payload) {
      context.commit('setBookingRequestObject', payload)
    }
  },
}

const booking = {
  namespaced: true,
  state: {
    bookingData: null
  },
  getters: {
    getBookingObject(state) {
      if (localStorage.getItem('bookingObject')) {
        state.bookingData = JSON.parse(localStorage.getItem('bookingObject'))
      }
      return state.bookingData
    }
  },
  mutations: {
    setBookingObject(state, payload) {
      localStorage.setItem('bookingObject', JSON.stringify(payload))
      state.bookingData = Object.assign([], payload)
    }
  },
  actions: {
    setBookingObject(context, payload) {
      context.commit('setBookingObject', payload)
    }
  },
}

const location = {
  namespaced: true,
  state: {
    locationData: null
  },
  getters: {
    getLocationData(state) {
      return state.locationData
    }
  },
  mutations: {
    setLocationData(state, payload) {
      state.locationData = payload
    }
  },
  actions: {
    setLocationData(context, payload) {
      context.commit('setLocationData', payload)
    }
  },
}

const regions = {
  namespaced: true,
  state: {
    regionsData: null
  },
  getters: {
    getRegions(state) {
      return state.regionsData
    }
  },
  mutations: {
    setRegions(state, payload) {
      state.regionsData = payload
    }
  },
  actions: {
    setRegions(context, payload) {
      context.commit('setRegions', payload)
    }
  },
}

const clientList = {
  namespaced: true,
  state: {
    clients: null
  },
  getters: {
    getClients(state) {
      return state.clients
    }
  },
  mutations: {
    setClients(state, payload) {
      state.clients = payload
    }
  },
  actions: {
    setClients(context, payload) {
      context.commit('setClients', payload)
    }
  },
}

const userList = {
  namespaced: true,
  state: {
    userList: null
  },
  getters: {
    getUsers(state) {
      return state.userList
    }
  },
  mutations: {
    setUsers(state, payload) {
      state.userList = payload
    }
  },
  actions: {
    setUsers(context, payload) {
      context.commit('setUsers', payload)
    }
  },
}

const locations = {
  namespaced: true,
  state: {
    locationsData: null
  },
  getters: {
    getLocations(state) {
      return state.locationsData
    }
  },
  mutations: {
    setLocations(state, payload) {
      state.locationsData = payload
    }
  },
  actions: {
    setLocations(context, payload) {
      context.commit('setLocations', payload)
    }
  },
}

const searchData = {
  namespaced: true,
  state: {
    searchData: null
  },
  getters: {
    getSearchData(state) {
      return state.searchData
    }
  },
  mutations: {
    setSearchData(state, payload) {
      state.searchData = payload
    }
  },
  actions: {
    setSearchData(context, payload) {
      context.commit('setSearchData', payload)
    }
  },
}

const qualification = {
  namespaced: true,
  state: {
    qualifications: null
  },
  getters: {
    getQualification(state) {
      return state.qualifications
    }
  },
  mutations: {
    setQualification(state, payload) {
      state.qualifications = payload
    }
  },
  actions: {
    setQualification(context, payload) {
      context.commit('setQualification', payload)
    }
  },
}

const bookingTypes = {
  namespaced: true,
  state: {
    bookingTypes: JSON.parse(localStorage.getItem('bookingTypes'))
  },
  getters: {
    getBookingTypes(state) {
      return state.bookingTypes
    }
  },
  mutations: {
    setBookingTypes(state, payload) {
      state.bookingTypes = payload
      localStorage.setItem('bookingTypes', JSON.stringify(payload))
    }
  },
  actions: {
    setBookingTypes(context, payload) {
      context.commit('setBookingTypes', payload)
    }
  },
}

const timeZones = {
  namespaced: true,
  state: {
    timeZones: JSON.parse(localStorage.getItem('timeZones'))
  },
  getters: {
    getTimeZones(state) {
      return state.timeZones
    }
  },
  mutations: {
    setTimeZones(state, payload) {
      state.bookingTypes = payload
      localStorage.setItem('timeZones', JSON.stringify(payload))
    }
  },
  actions: {
    setTimeZones(context, payload) {
      context.commit('setTimeZones', payload)
    }
  },
}

const stateCodes = {
  namespaced: true,
  state: {
    stateCodes: null
  },
  getters: {
    getStateCodes(state) {
      return state.stateCodes
    }
  },
  mutations: {
    setStateCodes(state, payload) {
      state.stateCodes = payload
    }
  },
  actions: {
    setStateCodes(context, payload) {
      context.commit('setStateCodes', payload)
    }
  },
}

const bodyAreas = {
  namespaced: true,
  state: {
    bodyAreas: JSON.parse(localStorage.getItem('bodyAreas'))
  },
  getters: {
    getBodyAreas(state) {
      return state.bodyAreas
    }
  },
  mutations: {
    setBodyArea(state, payload) {
      state.bodyAreas = payload
      localStorage.setItem('bodyAreas', JSON.stringify(payload))
    }
  },
  actions: {
    setBodyArea(context, payload) {
      context.commit('setBodyArea', payload)
    }
  },
}

const personConditions = {
  namespaced: true,
  state: {
    conditions: JSON.parse(localStorage.getItem('personConditions'))
  },
  getters: {
    getCondition(state) {
      return state.conditions
    }
  },
  mutations: {
    setConditions(state, payload) {
      state.conditions = payload
      localStorage.setItem('personConditions', JSON.stringify(payload))
    }
  },
  actions: {
    setConditions(context, payload) {
      context.commit('setConditions', payload)
    }
  },
}

const claimTypes = {
  namespaced: true,
  state: {
    claimTypes: null
  },
  getters: {
    getClaimTypes(state) {
      if (localStorage.getItem('claimTypes')) {
        state.claimTypes = JSON.parse(localStorage.getItem('claimTypes'))
      }
      return state.claimTypes
    }
  },
  mutations: {
    setClaimTypes(state, payload) {
      state.claimTypes = payload
      localStorage.setItem('claimTypes', JSON.stringify(payload))
    }
  },
  actions: {
    setClaimTypes(context, payload) {
      context.commit('setClaimTypes', payload)
    }
  },
}

const store = new Vuex.Store({
  namespaced: true,
  modules: {
    user,
    loading,
    booking,
    location,
    regions,
    locations,
    specialList,
    qualification,
    clientList,
    claimantConfirm,
    bookingTypes,
    claimTypes,
    searchData,
    bodyAreas,
    personConditions,
    stateCodes,
    userList,
    bookingRequest,
    timeZones
  },
  state: {
    // Admin
    currentLocation: null,
    originalObject: null,
    newObject: null,

    // Main
  },
  getters: {
    // Admin
    getCurrentLocation(state) {
      if (localStorage.getItem('currentLocation')) {
        state.currentLocation = JSON.parse(localStorage.getItem('currentLocation'))
      }
      return state.currentLocation
    },
    getOriginalObject(state) {
      if (localStorage.getItem('originalObject')) {
        state.originalObject = JSON.parse(localStorage.getItem('originalObject'))
      }
      return state.originalObject
    },
    getNewObject(state) {
      if (localStorage.getItem('newObject')) {
        state.newObject = JSON.parse(localStorage.getItem('newObject'))
      }
      return state.newObject
    },

    // Main
  },
  mutations: {
    // Admin
    setCurrentLocation(state, payload) {
      localStorage.setItem('currentLocation', JSON.stringify(payload))
      state.currentLocation = Object.assign([], payload)
    },
    setOriginalObject(state, payload) {
      localStorage.setItem('originalObject', JSON.stringify(payload))
      state.originalObject = Object.assign([], payload)
    },
    setNewObject(state, payload) {
      localStorage.setItem('newObject', JSON.stringify(payload))
      state.newObject = Object.assign([], payload)
    },

    // Main
  },
  actions: {
    // Admin
    setCurrentLocation(context, payload) {
      context.commit('setCurrentLocation', payload)
    },
    setOriginalObject(context, payload) {
      context.commit('setOriginalObject', payload)
    },
    setNewObject(context, payload) {
      context.commit('setNewObject', payload)
    },

    // Main
  },
})

export default store
